import { AddNewActionItemsAttachmentDetails } from "../common/action-attachment.model";
import { AddNewActionItemsAssignementDeatails } from "../common/assignment-details.model";
import { ExtMRPUpdateActionItem } from "./extension-MRP-update-line-item.model";

export class RequestExtMRPUpdateActionItemDetailsDto {
    items: ExtMRPUpdateActionItem[] = [];
    attachments?: AddNewActionItemsAttachmentDetails[];
    assignmentDetails?: AddNewActionItemsAssignementDeatails;

}